import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ContainerComponent } from './container.component';

export { ContainerComponent } from './container.component';

@NgModule({
  declarations: [
    ContainerComponent
  ],
  exports: [
    ContainerComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ContainerModule {}
